<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card content-crud">
          <div class="ibox-title" style="padding: 16px">
            <h3>Lista de Finalizados</h3>
            <!-- Status FastMedic -->
            <div class="mt-2" v-if="fastMedicStatus">
              <div
                class="alert"
                :class="{
                  'alert-success': fastMedicStatus.status === 'online',
                  'alert-warning': fastMedicStatus.status === 'error',
                  'alert-danger': fastMedicStatus.status === 'offline',
                }"
                style="margin-bottom: 0; padding: 8px 12px"
              >
                <i
                  class="fas"
                  :class="{
                    'fa-check-circle': fastMedicStatus.status === 'online',
                    'fa-exclamation-triangle ':
                      fastMedicStatus.status === 'error',
                    'fa-times-circle': fastMedicStatus.status === 'offline',
                  }"
                ></i>
                <strong> Prontuario:</strong> {{ fastMedicStatus.message }}
              </div>
            </div>
          </div>
          <div class="ibox-content">
            <div class="row" style="padding: 0px 0px 16px 16px">
              <div class="col-md-3">
                <label>Nº do Episódio</label>
                <input type="text" class="form-control" v-model="filtro.id" />
              </div>
              <div class="col-md-3">
                <label>Nome do Paciente</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filtro.nome_paciente"
                />
              </div>
              <div class="col-md-3">
                <label>Senha</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filtro.senha"
                />
              </div>
              <div class="col-md-3">
                <label>Data do Ínicio da Triagem</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filtro.inicio_classificacao"
                />
              </div>
              <div class="col-md-3 mt-1">
                <label>Data do Fim da Triagem</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filtro.fim_classificacao"
                />
              </div>
              <div class="col-md-3 mt-1">
                <label>Data da Entrada no Setor</label>
                <input
                  type="date"
                  class="form-control"
                  v-model="filtro.created_at"
                />
              </div>
              <div class="col-md-3 mt-1">
                <label>Fluxogramas</label>
                <select class="form-control" v-model="filtro.flowchart_id">
                  <option value=""></option>
                  <option
                    v-for="flowchart in flowcharts"
                    :key="flowchart.id"
                    :value="flowchart.id"
                  >
                    {{ flowchart.title }}
                  </option>
                </select>
              </div>
              <div class="col-md-3 mt-1">
                <label>Discriminadores</label>
                <select class="form-control" v-model="filtro.flowchart_item_id">
                  <option value=""></option>
                  <option
                    v-for="flowchart_item in flowchart_items"
                    :key="flowchart_item.id"
                    :value="flowchart_item.id"
                  >
                    {{ flowchart_item.title }}
                  </option>
                </select>
              </div>
              <div class="col-md-3 mt-1">
                <label>Classificação</label>
                <select class="form-control" v-model="filtro.classificacao">
                  <option value=""></option>
                  <option value="1">Vermelho</option>
                  <option value="2">Laranja</option>
                  <option value="3">Amarelo</option>
                  <option value="4">Verde</option>
                  <option value="5">Azul</option>
                  <option value="6">Branco</option>
                </select>
              </div>
              <div class="col-md-3 mt-1">
                <label>Integração Prontuário</label>
                <select class="form-control" v-model="filtro.status_fastmedic">
                  <option value=""></option>
                  <option value="1">Em Processamento</option>
                  <option value="3">Não Enviado</option>
                  <option value="4">Enviado</option>
                </select>
              </div>
              <div class="col-md-3 mt-1">
                <label>Profissional</label>
                <v-select
                  v-model="filtro.operador_id"
                  class="vselect"
                  :options="users"
                  :reduce="(user) => user.id"
                  label="name"
                  :clearable="true"
                />
              </div>
              <div class="row" style="margin-top: 40px">
                <div class="col-md-2">
                  <button class="btn btn-primary" @click="getEntity">
                    Filtrar
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="table-responsive-sm">
                  <table
                    role="table"
                    aria-busy="false"
                    aria-colcount="4"
                    class="table b-table"
                  >
                    <thead role="rowgroup" class="">
                      <tr role="row" class="">
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="1"
                          class=""
                        >
                          <div>Episódio</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="1"
                          class=""
                        >
                          <div>Classificação</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="1"
                          class=""
                        >
                          <div>Senha</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="2"
                          class=""
                        >
                          <div>Nome</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="3"
                          class=""
                        >
                          <div>Fluxograma</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="4"
                          class=""
                        >
                          <div>Data/Hora no Setor</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="4"
                          class=""
                        >
                          <div>Início da Triagem</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="4"
                          class=""
                        >
                          <div>Fim da Triagem</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="4"
                          class=""
                        >
                          <div>Integração Prontuário</div>
                        </th>
                        <th
                          role="columnheader"
                          scope="col"
                          aria-colindex="4"
                          class=""
                        >
                          <div>Ações</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody role="rowgroup">
                      <tr
                        role="row"
                        class=""
                        v-for="atendimento in atendimentos"
                        :key="atendimento.id"
                      >
                        <td aria-colindex="1" role="cell" class="">
                          {{ atendimento.id }}
                        </td>
                        <td aria-colindex="1" role="cell" class="">
                          <router-link
                            :to="'/triage/view/' + atendimento.id"
                            tag="button"
                            :class="
                              classificacaoColor(atendimento.classificacao)
                            "
                          >
                            {{ classificacaoLabel(atendimento.classificacao) }}
                          </router-link>
                        </td>
                        <td aria-colindex="1" role="cell" class="">
                          {{ atendimento.senha }}
                        </td>
                        <td aria-colindex="2" role="cell" class="">
                          {{
                            atendimento.paciente
                              ? atendimento.paciente.nome_social
                                ? atendimento.paciente.nome_social
                                : atendimento.paciente.nome_paciente
                              : "Informação não disponível"
                          }}
                        </td>
                        <td aria-colindex="3" role="cell" class="">
                          {{
                            atendimento.flowchart
                              ? atendimento.flowchart.title + " / "
                              : "BRANCO"
                          }}
                          {{
                            atendimento.classificacao == 5
                              ? "AZUL"
                              : atendimento.flowchart_item
                              ? atendimento.flowchart_item.title
                              : ""
                          }}
                        </td>
                        <td aria-colindex="4" role="cell" class="">
                          {{ atendimento.created_at_f }}
                        </td>
                        <td aria-colindex="4" role="cell" class="">
                          {{ atendimento.inicio_classificacao_f }}
                        </td>
                        <td aria-colindex="4" role="cell" class="">
                          {{ atendimento.fim_classificacao_f }}
                        </td>
                        <td aria-colindex="4" role="cell">
                          <span
                            class="badge badge-pill"
                            :class="{
                              'badge-warning':
                                atendimento.status_fastmedic_f ===
                                'Em Processamento',
                              'badge-success':
                                atendimento.status_fastmedic_f === 'Enviado',
                              'badge-danger':
                                atendimento.status_fastmedic_f ===
                                'Não Enviado',
                            }"
                            @click="
                              atendimento.status_fastmedic_f === 'Não Enviado'
                                ? openReenviarModal(atendimento)
                                : null
                            "
                            style="cursor: pointer"
                          >
                            {{ atendimento.status_fastmedic_f }}
                          </span>
                        </td>

                        <td aria-colindex="4" role="cell" class="">
                          <router-link
                            :to="'/triage/view/' + atendimento.id"
                            tag="button"
                            class="btn btn-crud info"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Visualizar Atendimento"
                          >
                            <i class="fas fa-eye"></i>
                          </router-link>
                          <button
                            class="btn btn-crud edit"
                            @click="imprimirFicha(atendimento)"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Imprimir Ficha de Classificação"
                          >
                            <i class="fas fa-print"></i>
                          </button>
                          <br />
                          <button
                            class="btn btn-crud edit"
                            @click="imprimirDeclaracao(atendimento)"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Imprimir Declaração"
                          >
                            <i class="fas fa-notes-medical"></i>
                          </button>
                          <button
                            v-if="$store.state.user.company_reclassificacao"
                            class="btn btn-crud delete"
                            @click="reclassificar(atendimento)"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Reclassificar"
                          >
                            <i class="fas fa-sync-alt"></i>
                          </button>
                          <button
                            class="btn btn-crud info"
                            @click="desfecho(atendimento)"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Desfecho"
                          >
                            <i class="fas fa-check"></i>
                          </button>
                        </td>
                      </tr>
                      <tr v-if="atendimentos.length == 0">
                        <td colspan="8" class="centered mt-2">
                          Nenhum atendimento na fila de triagem.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <b-modal
                v-if="showModal"
                v-model="showModal"
                title="Reenviar Integração"
                @ok="reenviarIntegracao"
              >
                <p>Deseja reenviar a integração para o prontuário?</p>
                <br />
                <p>
                  <strong>Mensagem de erro do prontuário:</strong>
                  {{ atendimentoSelecionado.mensagem_fastmedic }}
                </p>
              </b-modal>
              <div
                class="col-md-6 mx-auto d-flex justify-content-center align-items-center"
              >
                <pagination
                  :records="total"
                  :options="options"
                  :per-page="15"
                  @paginate="getEntity"
                ></pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Desfecho -->
    <div
      class="modal fade"
      id="modalDesfechoCenter"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalDesfechoCenterTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalDesfechoLongTitle">
              Incluir desfecho
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <label>Data de início do atendimento médico</label>
                <input
                  type="datetime-local"
                  class="form-control"
                  v-model="data_modal.data_inicio_atendimento"
                />
              </div>
              <div class="col-md-12 mt-1">
                <label>Desfecho</label>
                <v-select
                  v-model="data_modal.outcome_id"
                  class="vselect"
                  :options="outcomes"
                  :reduce="(outcomes) => outcomes.id"
                  :label="'title'"
                />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Fechar
            </button>
            <button type="button" class="btn btn-primary" @click="saveOutcome">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Pagination } from "vue-pagination-2";
export default {
  data() {
    return {
      atendimentos: [],
      outcomes: [],
      flowcharts: [],
      flowchart_items: [],
      users: [],
      filtro: {},
      data_modal: {},
      fastMedicStatus: null,
      options: {
        texts: {
          count: "Mostrando {from} de {to} até {count} de registros",
        },
        chunk: 4,
        chunksNavigation: "fixed",
      },
      total: 0,
      page: 1,
      showModal: false,
      atendimentoSelecionado: null,
    };
  },
  components: { Pagination },
  watch: {
    "filtro.flowchart_id": function (newFlowchartId) {
      this.getFlowchartItems(newFlowchartId);
    },
  },
  methods: {
    openReenviarModal(atendimento) {
      this.atendimentoSelecionado = atendimento;
      this.showModal = true;
    },
    reenviarIntegracao() {
      console.log("Reenviando atendimento ID:", this.atendimentoSelecionado.id);

      this.fastMedicIntegration();
      this.showModal = false;
    },
    fastMedicIntegration() {
      const self = this;

      if (!self.atendimentoSelecionado) return;

      let api = self.$store.state.api + "integra-fastmedic";

      self.atendimentoSelecionado._method = "POST";

      axios
        .post(api, self.atendimentoSelecionado)
        .then(() => {
          self.$message("Sucesso", "Classificação reenviada!", "success");
          self.getEntity();
          self.showModal = false;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    checkFastMedicStatus() {
      const self = this;

      let api = self.$store.state.api + "fastmedic-status";

      axios
        .get(api)
        .then((response) => {
          self.fastMedicStatus = response.data;
        })
        .catch((error) => {
          self.fastMedicStatus = {
            status: "error",
            message: "Erro ao verificar status do FastMedic",
          };
        });
    },

    desfecho(obj) {
      const self = this;

      self.data_modal = obj;

      $("#modalDesfechoCenter").modal("show");
    },
    reclassificar(obj) {
      const self = this;

      swal({
        title: "Tem certeza?",
        text: "O paciente será reclassificado.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Sim, prosseguir!",
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: "Não",
            value: "cancel",
            className: "btn-danger",
          },
          confirm: {
            text: "Sim",
            value: "confirm",
          },
        },
      }).then((value) => {
        switch (value) {
          case "cancel":
            swal("OK", "Prossiga na classificação", "info");
            break;

          case "confirm":
            let api = self.$store.state.api + "atendimentos/reclassificar";

            self.$loading(true);

            axios
              .post(api, obj)
              .then((response) => {
                var data = response.data;
                self.$loading(false);
                swal("OK", "Prossiga na classificação", "success");
                self.$router.push("/triage/flowchart/" + data.id);
              })
              .catch((error) => {
                self.$loading(false);
                self.$message(null, error.response.data, "error");
              });

            break;
        }
      });
    },
    imprimirFicha(obj) {
      const self = this;
      let url;

      // Se tem PDF armazenado, usa o novo sistema, senão usa o método antigo
      if (obj.pdf_path_atendimento) {
        url =
          self.$store.state.url +
          "atendimento/pdf/" +
          obj.id +
          "/" +
          self.user.id;
      } else {
        url =
          self.$store.state.url +
          "atendimento/impressao/" +
          obj.id +
          "/" +
          self.user.id;
      }

      window.open(url, "_blank").focus();
    },
    imprimirDeclaracao(obj) {
      const self = this;
      let url;

      // Se tem PDF armazenado, usa o novo sistema, senão usa o método antigo
      if (obj.pdf_path_declaracao) {
        url =
          self.$store.state.url +
          "atendimento/declaracao/pdf/" +
          obj.id +
          "/" +
          self.user.id;
      } else {
        url =
          self.$store.state.url +
          "atendimento/declaracao/impressao/" +
          obj.id +
          "/" +
          self.user.id;
      }

      window.open(url, "_blank").focus();
    },
    classificacaoLabel(classificacao) {
      if (classificacao == 1) {
        return "Vermelho";
      }

      if (classificacao == 2) {
        return "Laranja";
      }

      if (classificacao == 3) {
        return "Amarelo";
      }

      if (classificacao == 4) {
        return "Verde";
      }

      if (classificacao == 5) {
        return "Azul";
      }

      if (classificacao == 6) {
        return "Branco";
      }

      if (!classificacao) {
        return "Não Classificado";
      }
    },
    classificacaoColor(classificacao) {
      if (classificacao == 1) {
        return "btn-classificacao vermelho";
      }

      if (classificacao == 2) {
        return "btn-classificacao laranja";
      }

      if (classificacao == 3) {
        return "btn-classificacao amarelo";
      }

      if (classificacao == 4) {
        return "btn-classificacao verde";
      }

      if (classificacao == 5) {
        return "btn-classificacao azul";
      }

      if (classificacao == 6) {
        return "btn-classificacao branco";
      }

      if (!classificacao) {
        return "btn-classificacao cinza";
      }
    },
    diffIdade(data_nascimento) {
      const self = this;

      var a = moment();
      var b = moment(data_nascimento);

      var years = a.diff(b, "year");
      b.add(years, "years");

      var months = a.diff(b, "months");
      b.add(months, "months");

      var days = a.diff(b, "days");

      if (years < 100) {
        return years + " anos, " + months + " meses, " + days + " dias";
      }
    },
    getFlowcharts: function () {
      const self = this;
      let api = self.$store.state.api + "flowcharts?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          self.flowcharts = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    saveOutcome: function () {
      const self = this;
      let api = self.$store.state.api + "atendimento/save-desfecho";

      axios
        .post(api, self.data_modal)
        .then((response) => {
          self.getEntity();
          $("#modalDesfechoCenter").modal("hide");
          self.data_modal = {};
          self.$message(null, "Desfecho incluído com sucesso!", "success");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getOutcomes: function () {
      const self = this;
      let api = self.$store.state.api + "outcomes?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.outcomes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getFlowchartItems: function (flowchartId = null) {
      const self = this;
      let api =
        self.$store.state.api + "flowchart_items?paginated=false&status=1";

      if (flowchartId) {
        api += `&flowchart_id=${flowchartId}`;
      }

      axios
        .get(api)
        .then((response) => {
          self.flowchart_items = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers: function () {
      const self = this;
      let api = self.$store.state.api + "users?paginated=false";

      axios
        .get(api)
        .then((response) => {
          self.users = response.data.data || response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEntity: function (page) {
      const self = this;

      self.page = page;

      let api =
        self.$store.state.api +
        "get-atendimentos?status=1&with[]=flowchart&with[]=flowchart_item&with[]=razao&with[]=paciente&page=" +
        self.page;

      self.$loading(true);

      axios
        .post(api, self.filtro)
        .then((response) => {
          self.atendimentos = response.data.data;
          self.total = response.data.total;

          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
        });
    },

    search: _.debounce(function (e) {
      this.getEntity();
    }, 800),
    filtered_ic(date) {
      this.inicio_classificacao = date;
    },
    filtered_fc(date) {
      this.fim_classificacao = date;
    },
    filtered_de(date) {
      this.created_at = date;
    },
    // getEntity: function (id) {
    //   const self = this;
    //   let api =
    //     self.$store.state.api +
    //     "atendimentos?status=1&with[]=flowchart&with[]=flowchart_item";

    //   axios
    //     .get(api, self.atendimento)
    //     .then((response) => {
    //       self.atendimentos = response.data.data;
    //     })
    //     .catch((error) => {
    //       self.$message(null, error.response.data, "error");
    //     });
    // },
  },
  mounted() {
    const self = this;

    window.Echo.private("atendimento_status").listen(
      ".AtendimentoStatus",
      (e) => {
        console.log("websocket", e);
        if (e && e.atendimento) {
          const index = this.atendimentos.findIndex(
            (a) => a.id === e.atendimento.id
          );
          if (index !== -1) {
            this.atendimentos[index].status_fastmedic =
              e.atendimento.status_fastmedic;
            this.atendimentos[index].status_fastmedic_f =
              e.atendimento.status_fastmedic_f;
          }
        }
      }
    );

    self.getEntity();
    self.getFlowchartItems();
    self.getFlowcharts();
    self.getOutcomes();
    self.getUsers();
    self.checkFastMedicStatus();

    setTimeout(function () {
      self.user = self.$store.state.user;
    }, 200);

    // setTimeout(function () {
    //   $(function () {
    //     $('[data-toggle="tooltip"]').tooltip();
    //   });
    // }, 2000);
  },
  created() {},
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
</style>
